import { BodyText, Spinner, SpinnerProps } from '@servicetitan/design-system';

import { Container } from './LoadingIndicator.styled';

type Props = SpinnerProps & {
  show: boolean;
  title?: string;
  ['data-testid']?: string;
};

export const LoadingIndicator = (props: Props) => {
  const { show, title, ['data-testid']: dataTestId, ...spinnerProps } = props;
  if (!show) {
    return null;
  }

  return (
    <Container className='p-y-half m-l-half' data-testid={dataTestId}>
      <Spinner size='tiny' {...spinnerProps} />
      {title && (
        <BodyText subdued className='m-l-half'>
          {title}
        </BodyText>
      )}
    </Container>
  );
};

export default LoadingIndicator;
